import { render, staticRenderFns } from "./AvatarPreviewOnly.vue?vue&type=template&id=4fcd84ba&scoped=true"
import script from "./AvatarPreviewOnly.vue?vue&type=script&lang=js"
export * from "./AvatarPreviewOnly.vue?vue&type=script&lang=js"
import style0 from "./AvatarPreviewOnly.vue?vue&type=style&index=0&id=4fcd84ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fcd84ba",
  null
  
)

export default component.exports